import { swRequest } from "@sourcewhale/core";

export const getOrganization = (organizationId) =>
  swRequest({
    path: "/api/organizations/get",
    params: { organizationId },
  });
